import React from 'react'

const NotFound = () => {
    return <h1>403 - Access Denied</h1>
}

export default NotFound
